<script lang="ts">
  import { click } from '../game/Sfx';
  import ClassGrid from './ClassGrid.svelte';

  let { onclose }: { onclose: () => void } = $props();

  function onKey(event: KeyboardEvent) {
    if (event.code !== 'Escape') return;
    event.preventDefault();
    event.stopPropagation();
    click();
    onclose();
  }
</script>

<svelte:window onkeydowncapture={onKey} />

<section class="panel classes">
  <header>
    <h2>Class</h2>
    <button class="close" onclick={onclose} aria-label="Close">×</button>
  </header>

  <div class="content">
    <ClassGrid />
  </div>
</section>

<style>
  .classes {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: grid;
    grid-template-rows: auto minmax(0, 1fr);
    width: min(760px, calc(100% - 24px));
    max-height: min(640px, calc(100% - 48px));
    padding: 0;
    pointer-events: auto;
    background: var(--panel-solid);
    border-color: var(--gold);
    box-shadow: 0 6px 24px rgba(0, 0, 0, 0.6);
    font-size: 14px;
  }
  header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 18px;
    border-bottom: 1px solid var(--border);
  }
  header h2 {
    margin: 0;
  }
  .close {
    padding: 0 8px;
    font-size: 18px;
  }
  .content {
    overflow-y: auto;
    padding: 14px 18px;
  }
</style>
